import { render, staticRenderFns } from "./data-breach.vue?vue&type=template&id=473c848e&scoped=true"
import script from "./data-breach.vue?vue&type=script&lang=js"
export * from "./data-breach.vue?vue&type=script&lang=js"
import style0 from "./data-breach.vue?vue&type=style&index=0&id=473c848e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c848e",
  null
  
)

export default component.exports